<template>
  <div
    class="ui-form-item f-item-row"
    :data-key="itemData.fieldkey"
    :data-type="itemData.fieldtype"
    :class="{'borderCl': itemData.isActive}"
    @click="getData"
  >
    <i class="iconfont icon iconicon-test72" />
    <!-- <i
      v-if="!itemData.ishidden"
      class="iconfont icon iconicon-test86"
      @click="setHide"
    /> -->
    <i
      v-if="itemData.isdelete"
      class="iconfont icon iconicon-test8"
      @click.stop="deleteItem"
    />
    <label class="ui-label f-item-label">
      <span
        v-if="itemData.isneeded"
        class="ui-form-required need-tip"
      >*</span>
      {{ itemData.label }}：
    </label>
    <div class="f-item-cell">
      <input
        v-if="inputType"
        class="f-input-text"
        type="text"
        :value="itemData.defaultvalue"
        :placeholder="itemData.placeholder"
        disabled
      >
      <template v-else-if="treeType">
        <select
          :placeholder="itemData.placeholder"
          class="f-select"
          style="color:#d8d8d8;"
          disabled
        >
          <option>{{ itemData.placeholder }}</option>
        </select>
      </template>
      <template v-else-if="radioType">
        <template v-for="option in itemData.options">
          <label
            v-if="option.isshow"
            :key="option.id"
            :for="option.id"
            class="f-r-c-label"
          >
            <input
              :id="option.id"
              class="f-chekbox-radio"
              :value="option.id"
              :checked="itemData.defaultvalue === option.id ? 'checked': false"
              type="radio"
              disabled
            >
            {{ option.showname || option.name }}
          </label>
        </template>
      </template>
      <template v-else-if="checkboxType">
        <template v-for="option in itemData.options">
          <label
            v-if="option.isshow"
            :key="option.id"
            :for="option.id"
            class="f-r-c-label"
          >
            <input
              :id="option.id"
              class="f-chekbox-radio"
              :value="option.id"
              :checked="itemData.defaultvalue.indexOf(option.id)> -1? 'checked': false"
              type="checkbox"
              disabled
            >
            {{ option.showname || option.name }}
          </label>
        </template>
      </template>
      <template v-else-if="selectType">
        <select
          class="f-select"
          disabled
          style="color:#d8d8d8;"
        >
          <!-- <template v-for="option in itemData.options">
            <option
              v-if="option.isshow"
              :key="option.id"
              :selected="itemData.defaultvalue === option.id ? 'selected' : false"
              :value="option.showname || option.name"
            >
              {{ option.showname || option.name }}
            </option>
          </template> -->
          <option>{{ itemData.placeholder }}</option>
        </select>
      </template>
      <template v-else-if="areaType">
        <select
          v-if="areaShow === 1 || areaShow ===2 "
          class="area-select f-select mrt"
          style="color:#d8d8d8;"
          disabled
        >
          <option>
            {{ itemData.placeholder.select }}
          </option>
        </select>
        <input
          v-if="areaShow === 1 || areaShow ===3 "
          class="f-input-text area-input-text"
          type="text"
          name=""
          :value="itemData.defaultvalue.address"
          :placeholder="itemData.placeholder.input"
          disabled
        >
      </template>
      <template v-else-if="editorType">
        <div class="editor-type">
          {{ itemData.defaultvalue }}
        </div>
      </template>
      <template v-else-if="fileType">
        <a-button>
          {{ itemData.placeholder }}
        </a-button>
      </template>
      <span
        v-if="itemData.ishidden"
        class="isHide"
      >
        <i
          class="iconfont iconicon-test86"
          @click="setHide"
        />
        {{ $t('message["1481"]') }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import eventBus from '@/lib/eventBus'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState('universalForm/form', ['formDefaultDatas', 'infoDatas']),
    inputType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'text' || fieldtype === 'number' || fieldtype === 'phone' || fieldtype === 'datetime' || fieldtype === 'email'
    },
    checkboxType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'checkbox'
    },
    editorType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'editor'
    },
    radioType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'radio'
    },
    selectType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'select'
    },
    areaType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'area'
    },
    treeType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'select_tree'
    },
    fileType () {
      const { fieldtype } = this.itemData
      return fieldtype === 'file'
    },
    areaShow () {
      const { itemData = {} } = this
      const { fieldconfig = {} } = itemData
      const { format = 2 } = fieldconfig
      return format
    }
  },
  created () {
    if (this.itemData.fieldtype === 'file') {
      this.itemData.placeholder = this.itemData.placeholder || this.$t('message["986"]')
    }
  },
  methods: {
    ...mapMutations('universalForm/form', ['setIsBorder', 'setFormItemData']),
    getData () {
      this.formDefaultDatas.forEach((item) => {
        item.isActive = false
      })
      this.setIsBorder(false)
      this.itemData.isActive = true
      eventBus.$emit('getItemData', this.itemData)
      // this.setFormItemData(this.itemData)
    },
    setHide () {
      this.itemData.ishidden = true
    },
    deleteItem () {
      const { formDefaultDatas, infoDatas, itemData } = this
      eventBus.$emit('delItem', this.itemData)
      formDefaultDatas.splice(this.index, 1)
      for (let i in infoDatas) {
        if (infoDatas[i].child) {
          infoDatas[i].child.forEach(item => {
            if (item.fieldkey === itemData.fieldkey) {
              item.checked = false
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.f-item-row {
  position: relative;
  .icon {
    position: absolute;
    color: #d8d8d8;
    font-size: 16px;
    cursor: pointer;
    top: 15px;
    display: none;
  }
  .area-select {
    margin-bottom: 24px;
  }
  .iconicon-test72 {
    left: 16px;
  }
  .iconicon-test86 {
    right: 40px;
  }
  .iconicon-test8 {
    right: 16px;
  }
}
.f-item-row:hover {
  background: #f4f7f9;
  .icon {
    display: inline-block;
  }
}
.borderCl {
  border: 1px solid #5077aa;
  background: #f4f7f9;
}
.isHide {
  color: #d8d8d8;
  .iconicon-test86 {
    font-size: 16px;
    color: #d8d8d8;
  }
  margin-left: 16px;
}
.editor-type {
  width: 300px;
  height: 122px;
  padding: 60px 10px 10px;
  width: 320px;
  display: inline-block;
  background: url(../../../assets/images/editor.png) no-repeat 0 0;
  vertical-align: middle;
  background-size: 320px 192px;
  box-sizing: content-box;
}
</style>
